import { Component } from '@angular/core';
import { AuthenticationService } from '@cbuild/core';

@Component({
  selector: 'cs-no-projects',
  standalone: false,
  templateUrl: './no-projects.component.html',
  styleUrls: ['./no-projects.component.scss']
})
export class NoProjectsComponent {
  constructor(private authenticationService: AuthenticationService) {}

  public logout(): void {
    this.authenticationService.logOut();
  }
}
